import { Component } from '@angular/core';

@Component({
  selector: 'app-invoices',
  template: '<router-outlet></router-outlet>'
})
export class InvoicesComponent { }
